

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Register from "./frontend/pages/Register/Register";
import Home from "./frontend/pages/Home/Home"
import SingleIct from "./frontend/components/Courses/SingleIct"
import SingleWebDevelopment from "./frontend/components/Courses/SingleWebDevelopment";
import SingleWebDesign from "./frontend/components/Courses/SingleWebDesign";
import SingleOffice from "./frontend/components/Courses/SingleOffice";

function App() {
  return (
    <>
      <BrowserRouter>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/reg" element={<Register />} />
          <Route path="/hsc-ict-course" element={<SingleIct />} />
          <Route path="/web-development-course" element={<SingleWebDevelopment />} />
          <Route path="/web-design-course" element={<SingleWebDesign />} />
          <Route path="/computer-office-application" element={<SingleOffice />} />
        </Routes>


      </BrowserRouter>


    </>
  );
}

export default App;
